import { render, staticRenderFns } from "./EditPlanCategory.vue?vue&type=template&id=520c9fcf&"
import script from "./EditPlanCategory.vue?vue&type=script&lang=js&"
export * from "./EditPlanCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports